<template lang="pug">
.tab
  .tab-item(
    v-for="item, i in tabs"
    :key="i"
    :class="{active: i === index}"
    :title="item"
    @click="$emit('change', i)"
  ) {{ item }}
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array
    },
    index: {
      type: Number
    }
  }
}
</script>

<style lang="stylus" scoped>
.tab
  display flex

.tab-item
  width 105px
  height 38px
  padding 0 10px
  display inline-block
  border-radius 4px
  border 1px solid #5f99f6
  color #5f99f6
  margin-right 20px
  cursor pointer
  overflow hidden
  text-overflow ellipsis
  white-space nowrap
  line-height 38px
  text-align center
  &.active
    background-color #5f99f6
    color white
</style>
